// Vulders Trading theme. Swinging wall, live search, Ajax cart drawer, try-on-your-wall, filters, product. No dependencies.
(() => {
const C = window.VTC || {};
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
const nf = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: C.currency || 'EUR' });
const money = (cents) => nf.format((cents || 0) / 100);
const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const norm = (s) => String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’]/g, '');
const sized = (url, w) => { if (!url) return ''; const u = new URL(url, location.href); u.searchParams.set('width', w); u.searchParams.delete('height'); return u.href; };
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const json = (el) => { try { return JSON.parse(el?.textContent || 'null'); } catch (e) { return null; } };
const sectionUrl = (url, id) => { const u = new URL(url, location.href); u.searchParams.set('section_id', id); return u.href; };
const parseHTML = (t) => new DOMParser().parseFromString(t, 'text/html');
// the theme editor re-renders a section in place without re-running scripts: section code is an init(root) that runs
// once for the page and again for each section the editor re-renders, so the editor never has to reload the preview
const inits = [];
const onSection = (fn) => { inits.push(fn); fn(document); };

// ---------- product shape shared by Liquid (snippets/vt-json) and the JSON endpoints ----------
// { id: variant id, h: handle, n: display name, k: type, p: price cents, u: url, i: image, b: back image, r: ratio, s: size label, a: available }
function nameOf(title) {
  const parts = String(title).split('|').map((s) => s.trim()).filter(Boolean);
  if (parts.length < 2) return parts[0] || String(title);
  const extra = parts.slice(2).filter((x) => !/cm|rond/i.test(x));
  return [parts[1], ...extra].join(' · ');
}
function sizeLabel(text, title, type) {
  const round = /rond/i.test(title) || /drankdop/i.test(type || '');
  const t = String(text || '').replace(/<[^>]+>/g, ' ');
  let m = t.match(/Afmeting[^0-9]*(\d+(?:[.,]\d+)?)\s*(?:\(L\))?\s*x\s*(\d+(?:[.,]\d+)?)/i) || String(title).match(/(\d+)\s*x\s*(\d+)\s*cm/i);
  if (m) {
    const a = parseFloat(m[1].replace(',', '.')), b = parseFloat(m[2].replace(',', '.'));
    return round ? `Ø ${Math.max(a, b)} cm` : `${a} × ${b} cm`;
  }
  m = String(title).match(/(\d+(?:,\d+)?)\s*cm/i);
  return m && round ? `Ø ${m[1]} cm` : '';
}
function fromSuggest(p) {
  const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0] || {};
  return { id: v.id, h: p.handle, n: nameOf(p.title), k: p.type, p: Math.round(parseFloat(v.price ?? p.price) * 100), u: p.url, i: p.featured_image?.url || p.image, b: '', r: p.featured_image?.aspect_ratio || 0, s: sizeLabel(p.body, p.title, p.type), a: p.available };
}
function fromProductsJson(p) {
  const v = p.variants.find((x) => x.available) || p.variants[0], im = p.images || [];
  return { id: v.id, h: p.handle, n: nameOf(p.title), k: p.product_type, p: Math.round(parseFloat(v.price) * 100), u: `${C.root || '/'}products/${p.handle}`.replace('//', '/'), i: im[0]?.src || '', b: im[1]?.src || '', r: im[0] ? im[0].width / im[0].height : 0, s: sizeLabel(p.body_html, p.title, p.product_type), a: v.available };
}
// Real-world size in cm; orientation follows the photo (landscape photo → longest side is the width).
function sizeOf(d, ratio) {
  const m = String(d.s || '').match(/(\d+(?:[.,]\d+)?)(?:\s*×\s*(\d+(?:[.,]\d+)?))?/);
  if (!m) return null;
  const a = parseFloat(m[1].replace(',', '.')), b = m[2] ? parseFloat(m[2].replace(',', '.')) : a;
  if (/Ø/.test(d.s)) return { w: Math.max(a, b), h: Math.max(a, b) };
  const r = ratio || d.r || 1.25;
  return r >= 1 ? { w: Math.max(a, b), h: Math.min(a, b) } : { w: Math.min(a, b), h: Math.max(a, b) };
}

// Predictive search returns no variants; look the variant up when it is actually needed.
async function withVariant(d) {
  if (d.id) return d;
  try {
    const p = await (await fetch(`${d.u.split('?')[0]}.js`, { headers: { Accept: 'application/json' } })).json();
    const v = p.variants.find((x) => x.available) || p.variants[0];
    d.id = v.id; d.p = v.price; d.a = v.available;
  } catch (e) { /* stays without id; the cart skips it */ }
  return d;
}

// ---------- predictive search (Shopify) ----------
async function suggest(q, limit = 6, signal) {
  const u = new URL(`${C.suggest}.json`, location.href);
  u.searchParams.set('q', q);
  u.searchParams.set('resources[type]', 'product');
  u.searchParams.set('resources[limit]', limit);
  u.searchParams.set('resources[options][unavailable_products]', 'last');
  u.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,tag,vendor');
  const r = await fetch(u, { signal, headers: { Accept: 'application/json' } });
  if (!r.ok) return [];
  const j = await r.json();
  return (j.resources?.results?.products || []).map(fromSuggest);
}
const searchUrl = (q) => `${C.search}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last`;

// ---------- toast ----------
const toastEl = $('[data-toast]');
let toastT = 0;
const toast = (t) => { if (!toastEl) return; toastEl.textContent = t; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2600); };

// ---------- cart (Shopify Ajax Cart API) ----------
// ---------- quick add: the sign's photo flies into the cart in the header, so you see where it went ----------
// A copy of the card photo travels to the cart icon (transform + opacity only), the icon gives a small bump on landing.
// Reduced motion, a missing photo or a cart icon out of view: no flight, the caller shows its usual toast instead.
function flyToCart(img) {
  const target = $('.hdr__cart .hdr__cart-icon'); // the heart shares the icon wrapper; aim at the cart itself
  if (reduce || !img || !target) return false;
  const a = img.getBoundingClientRect(), t = target.getBoundingClientRect();
  if (!a.width || !t.width || t.bottom < 0 || t.top > innerHeight) return false;
  const ghost = new Image();
  ghost.src = img.currentSrc || img.src; ghost.alt = ''; ghost.className = 'fly';
  Object.assign(ghost.style, { left: `${a.left}px`, top: `${a.top}px`, width: `${a.width}px`, height: `${a.height}px` });
  document.body.append(ghost);
  const dx = t.left + t.width / 2 - (a.left + a.width / 2), dy = t.top + t.height / 2 - (a.top + a.height / 2);
  const s = Math.max(0.1, 26 / a.width);
  ghost.animate([
    { transform: 'translate(0, 0) scale(1)', opacity: 1 },
    { transform: `translate(${dx * 0.75}px, ${dy * 0.75}px) scale(${(1 + s) / 2.4})`, opacity: 1, offset: 0.75 },
    { transform: `translate(${dx}px, ${dy}px) scale(${s})`, opacity: 0 },
  ], { duration: 460, easing: 'cubic-bezier(0.77, 0, 0.175, 1)' }).onfinish = () => {
    ghost.remove();
    target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 240, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
    cart.bump();
  };
  return true;
}

const cart = (() => {
  const root = $('[data-cart]');
  const count = $('[data-cart-count]');
  if (!root) return { add: async () => {}, open() {}, refresh() {} };
  const list = $('[data-cart-list]', root), codeMsg = $('[data-code-msg]', root); // codes are entered in Shopify Checkout
  let state = null, lastFocus = null;
  const api = async (url, body) => {
    const r = await fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Er ging iets mis');
    return j;
  };
  const BAG = '<svg viewBox="0 0 24 24"><path d="M2.5 3.5h2.6l2.3 11.1a1.5 1.5 0 0 0 1.5 1.2h8.3a1.5 1.5 0 0 0 1.5-1.1l1.8-7.4H5.9"/><circle cx="9.6" cy="19.8" r="1.3"/><circle cx="17.4" cy="19.8" r="1.3"/></svg>';
  const BIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5.5 7l1 12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2l1-12M9 7V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V7"/></svg>';
  const TAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9Z"/><circle cx="8" cy="8" r="1.5"/></svg>';
  // Every discount Shopify applied, by name: automatic ones sit on the lines, codes on the whole cart.
  function discountsOf(c) {
    const m = new Map();
    c.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => {
      const t = a.discount_application?.title || 'Korting'; m.set(t, (m.get(t) || 0) + a.amount);
    }));
    (c.cart_level_discount_applications || []).forEach((a) => { const t = a.title || 'Korting'; m.set(t, (m.get(t) || 0) + a.total_allocated_amount); });
    // whatever Shopify does not name still shows, so the rows always add up to the total
    const named = [...m.values()].reduce((x, y) => x + y, 0), rest = c.original_total_price - c.total_price - named;
    if (rest > 0) m.set('Korting', (m.get('Korting') || 0) + rest);
    return [...m].filter(([, v]) => v > 0);
  }
  function render(c) {
    state = c;
    const n = c.item_count, sub = c.original_total_price, total = c.total_price, saved = Math.max(0, sub - total);
    const left = Math.max(0, (C.freeShipping || 0) - total);
    if (!hold) { count.textContent = n || ''; count.toggleAttribute('data-zero', !n); }
    list.innerHTML = c.items.length ? c.items.map((it) => {
      const name = esc(nameOf(it.product_title));
      const tags = [...new Set((it.line_level_discount_allocations || []).map((a) => a.discount_application?.title).filter(Boolean))];
      // like the shop's reference: photo left; name with a bin; size; quantity left and the line total right
      const size = it.product_has_only_default_variant === false && it.variant_title ? it.variant_title : sizeLabel(it.product_description, it.product_title, it.product_type);
      const line = it.final_price * it.quantity, was = it.original_price * it.quantity;
      return `<li class="cl" data-key="${esc(it.key)}">
      <a class="cl__img" href="${esc(it.url)}" tabindex="-1" aria-hidden="true"><img src="${esc(sized(it.image, 200))}" alt="" width="88" height="88" loading="lazy"></a>
      <div class="cl__head"><p class="cl__name"><a href="${esc(it.url)}">${name}</a></p><button type="button" class="cl__del" data-cq="${esc(it.key)}" data-q="0" aria-label="Verwijder ${name} uit je winkelwagen">${BIN}</button></div>
      <div class="cl__meta">${size ? `<span>Maat: ${esc(size)}</span>` : ''}${tags.map((t) => `<span class="cart__tag">${TAG}${esc(t)}</span>`).join('')}</div>
      <div class="cl__foot"><div class="qty"><button type="button" data-cq="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Eén minder ${name}">−</button><input value="${it.quantity}" readonly aria-label="Aantal"><button type="button" data-cq="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Eén meer ${name}">+</button></div>
      <span class="cl__price">${was !== line ? `<s>${money(was)}</s> ` : ''}<b>${money(line)}</b></span></div></li>`;
    }).join('')
      : `<li class="cart__empty"><span class="cart__empty-icon" aria-hidden="true">${BAG}</span><p>Je winkelwagen is nog leeg.</p><small>Tijd voor een bord aan de muur.</small><a class="btn btn--accent" href="${esc(C.cartEmpty || C.all)}">Bekijk alle wandborden</a></li>`;
    root.classList.toggle('is-empty', !n); // empty: no €0 totals, no disabled checkout
    const ship = $('[data-ship]', root);
    if (ship) {
      ship.innerHTML = !n ? `Gratis verzending vanaf <b>${money(C.freeShipping)}</b> in NL en België.` : left > 0 ? `Nog <b>${money(left)}</b> tot gratis verzending.` : '<b>Gratis verzending</b> is binnen.';
      $('[data-ship-bar]', root).style.width = `${Math.min(100, (total / (C.freeShipping || 1)) * 100)}%`;
    }
    const shipCost = !n ? '–' : left > 0 || !C.freeShipping ? 'Bij afrekenen' : 'Gratis';
    // product page line above "In winkelwagen" follows the same cart total
    $$('[data-ship-text]').forEach((el) => { el.innerHTML = left > 0 ? `Nog <b>${money(left)}</b> tot gratis verzending` : '<b>Gratis verzending</b> is binnen!'; });
    $('[data-sum]', root).innerHTML = `<div><dt>Subtotaal</dt><dd>${money(sub)}</dd></div>`
      + discountsOf(c).map(([t, v]) => `<div class="cart__disc"><dt>${TAG}${esc(t)}</dt><dd>− ${money(v)}</dd></div>`).join('')
      + `<div><dt>Verzending</dt><dd>${shipCost}</dd></div>`
      + `<div class="cart__total"><dt>Totaal</dt><dd>${saved ? `<s>${money(sub)}</s> ` : ''}${money(total)}</dd></div>`
      + (saved && C.savings ? `<div class="cart__saved"><dt>Je bespaart</dt><dd>${money(saved)}</dd></div>` : '');
    $('[data-checkout]', root).disabled = !n;
    drawUp();
  }
  // ---------- bestsellers with a + under the lines (sections/cart-bestsellers, best-selling first) ----------
  // Loaded once, when the drawer first opens or something is added. A sign that lands in the cart leaves the row
  // (a tick first when it was tapped there), the next bestseller moves up; one taken out of the cart comes back.
  const up = $('[data-cup]', root), upTrack = up && $('[data-cup-track]', up), UP_MAX = 15;
  let pool = null, upLoad = null;
  function loadUp() {
    if (!up || upLoad) return;
    const u = new URL(up.dataset.src, location.href);
    u.searchParams.set('section_id', 'cart-bestsellers'); u.searchParams.set('sort_by', 'best-selling');
    upLoad = fetch(u).then((r) => (r.ok ? r.text() : '')).then((t) => { pool = $$('[data-cup-pool] > li', parseHTML(t)); drawUp(); }, () => { pool = []; });
  }
  function leaveUp(li) {
    li.classList.add('is-out');
    const done = () => {
      const rest = $$(':scope > li', upTrack).filter((x) => x !== li), was = rest.map((x) => x.getBoundingClientRect().left);
      li.remove();
      if (!reduce) rest.forEach((x, i) => { const d = was[i] - x.getBoundingClientRect().left; if (d) x.animate([{ transform: `translateX(${d}px)` }, { transform: 'none' }], { duration: 280, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }); });
      drawUp();
    };
    if (reduce) return done();
    li.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.9)' }], { duration: 180, delay: li.classList.contains('is-added') ? 320 : 0, easing: 'ease-in', fill: 'forwards' }).onfinish = done;
  }
  function drawUp() {
    if (!pool || !upTrack) return;
    const inCart = new Set((state?.items || []).map((it) => String(it.variant_id)));
    $$(':scope > li:not(.is-out)', upTrack).forEach((li) => { if (inCart.has(li.dataset.v)) leaveUp(li); });
    const shown = $$(':scope > li:not(.is-out)', upTrack), have = new Set($$(':scope > li', upTrack).map((li) => li.dataset.v));
    for (const li of pool) {
      if (shown.length >= UP_MAX) break;
      if (inCart.has(li.dataset.v) || have.has(li.dataset.v)) continue;
      const n = document.importNode(li, true); upTrack.append(n); shown.push(n); have.add(li.dataset.v);
    }
    up.hidden = !upTrack.children.length;
  }
  up?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cup-add]'); if (!b || b.disabled) return;
    b.disabled = true; b.closest('li').classList.add('is-added');
    add([{ id: b.dataset.cupAdd, title: b.dataset.name, price: Number(b.dataset.price) || 0, image: b.dataset.img, url: b.dataset.url }], { quiet: true });
  });
  // Optimistic cart: a tap updates the count, drawer and totals at once from what we know; Shopify's answer (0.4–0.7 s)
  // replaces that guess when the last queued request is back. Requests run one after another, so quick taps stay in order.
  let pending = 0, chain = Promise.resolve(), hold = false; // hold: a flying photo is on its way, the count changes when it lands
  const queue = (job) => (chain = chain.then(job, job));
  async function refresh() {
    if (pending) return;
    try { const c = await api(`${C.cart}.js`); if (!pending) render(c); } catch (e) { /* keep server-rendered count */ }
  }
  const bump = () => {
    if (hold && state) { hold = false; count.textContent = state.item_count || ''; count.toggleAttribute('data-zero', !state.item_count); }
    count.classList.remove('is-bump'); void count.offsetWidth; count.classList.add('is-bump');
  };
  // items may carry a preview (title, price in cents, image, url) so a new line can show before Shopify confirms it
  function withAdded(c, items) {
    const n = structuredClone(c);
    items.forEach((x) => {
      const q = x.quantity || 1, id = Number(x.id);
      let it = n.items.find((i) => i.variant_id === id);
      if (it) it.quantity += q;
      else if (x.title) { it = { key: `pending-${id}`, variant_id: id, product_title: x.title, image: x.image || '', url: x.url || '#', original_price: x.price || 0, final_price: x.price || 0, quantity: q, line_level_discount_allocations: [] }; n.items.unshift(it); }
      n.item_count += q;
      if (it) { n.original_total_price += it.original_price * q; n.total_price += it.final_price * q; }
    });
    return n;
  }
  async function add(items, { quiet = false, label = '', land = true } = {}) {
    const before = state;
    loadUp();
    if (!land) hold = true;
    if (state) render(withAdded(state, items));
    else { const n = (Number(count.textContent) || 0) + items.reduce((a, x) => a + (x.quantity || 1), 0); count.textContent = n; count.removeAttribute('data-zero'); }
    if (land) bump();
    if (!quiet) toast(`${label || 'Bord'} toegevoegd`);
    pending++;
    try {
      await queue(() => api(`${C.cartAdd}.js`, { items: items.map((x) => ({ id: Number(x.id), quantity: x.quantity || 1 })) }));
      pending--; refresh();
      if (document.body.classList.contains('page-cart')) refreshCartPage();
      return true;
    } catch (e) {
      pending--; if (before && !pending) render(before);
      refresh(); toast(e.message); return false;
    }
  }
  // the cart page itself is rendered by Liquid: fetch it again so a sign added from the upsell rail shows up there too
  async function refreshCartPage() {
    try {
      const d = parseHTML(await (await fetch(location.pathname)).text());
      const next = $('.page--cart', d), now = $('.page--cart');
      if (next && now) now.replaceWith(next);
      const eb = $('[data-upsell] .eyebrow', d), ebNow = $('[data-upsell] .eyebrow'); // "nog € … tot gratis verzending"
      if (eb && ebNow) ebNow.textContent = eb.textContent;
    } catch (e) { /* the drawer is still right */ }
  }
  async function setCode(code, { silent = false } = {}) {
    code = code.trim().toUpperCase();
    try {
      let c = await api(`${C.cartUpdate}.js`, { discount: code });
      c = await api(`${C.cart}.js`).catch(() => c); // update.js can answer before the code's allocation is listed
      render(c);
      if (silent || !codeMsg) return;
      const d = (c.discount_codes || []).find((x) => x.code.toUpperCase() === code);
      codeMsg.textContent = !code ? '' : d && d.applicable ? `Code ${code} is toegepast.` : d ? `Code ${code} geldt (nog) niet voor deze producten.` : `Code ${code} wordt bij afrekenen gecontroleerd.`;
    } catch (e) { if (!silent && codeMsg) codeMsg.textContent = e.message; }
  }
  function open() {
    lastFocus = document.activeElement; root.hidden = false; document.documentElement.classList.add('is-locked');
    $('.cart__head button', root).focus(); refresh(); loadUp();
  }
  function close() { root.hidden = true; document.documentElement.classList.remove('is-locked'); lastFocus?.focus?.(); }
  document.addEventListener('click', (e) => { if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); } }); // header and hero buttons, also after the editor re-renders them
  $$('[data-cart-close]', root).forEach((b) => b.addEventListener('click', close));
  // touch: swipe the drawer to the right to close it; it follows the finger and springs back when let go early
  const panel = $('.cart__panel', root);
  let tx = 0, ty = 0, dx = 0, dragging = null;
  // a finger on the bestseller row scrolls the row, it does not close the drawer
  panel.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; dx = 0; dragging = e.target.closest('[data-cup-track]') ? false : null; panel.style.transition = 'none'; }, { passive: true });
  panel.addEventListener('touchmove', (e) => {
    const x = e.touches[0].clientX - tx, y = e.touches[0].clientY - ty;
    if (dragging === null && (Math.abs(x) > 8 || Math.abs(y) > 8)) dragging = x > 0 && Math.abs(x) > Math.abs(y) * 1.3;
    if (!dragging) return;
    dx = Math.max(0, x); panel.style.transform = `translateX(${dx}px)`;
  }, { passive: true });
  panel.addEventListener('touchend', () => {
    if (!dragging) { panel.style.transition = ''; return; }
    const shut = dx > Math.min(120, panel.offsetWidth * 0.3);
    panel.style.transition = reduce ? 'none' : 'transform .24s cubic-bezier(0.23, 1, 0.32, 1)';
    panel.style.transform = shut ? 'translateX(100%)' : '';
    if (shut) setTimeout(() => { close(); panel.style.transition = ''; panel.style.transform = ''; }, reduce ? 0 : 230);
    else setTimeout(() => { panel.style.transition = ''; }, 260);
    dragging = null;
  }, { passive: true });
  document.addEventListener('keydown', (e) => {
    if (root.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { // keep focus inside the drawer
      const f = $$('a[href], button:not([disabled]), input', $('.cart__panel', root)).filter((x) => x.offsetParent);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    }
  });
  list.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cq]'); if (!b || !state) return;
    const key = b.dataset.cq; if (key.startsWith('pending-')) return; // a line Shopify has not confirmed yet
    const want = Math.max(0, Number(b.dataset.q));
    const n = structuredClone(state), it = n.items.find((x) => x.key === key); if (!it) return;
    const d = want - it.quantity;
    n.item_count += d; n.original_total_price += it.original_price * d; n.total_price += it.final_price * d;
    it.quantity = want; if (!want) n.items = n.items.filter((x) => x !== it);
    render(n);
    pending++;
    queue(() => api(`${C.cartChange}.js`, { id: key, quantity: want })).then((c) => {
      if (--pending) return;
      render(c);
      if (document.body.classList.contains('page-cart')) refreshCartPage();
      const got = c.items.find((x) => x.key === key)?.quantity ?? 0;
      if (got < want) toast(`Nog maar ${got} op voorraad`);
    }, (err) => { pending--; toast(err.message); refresh(); });
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add]'); if (!b) return;
    e.preventDefault();
    const flew = flyToCart(b.closest('.pc')?.querySelector('.pc__img img'));
    add([{ id: b.dataset.add, title: b.dataset.name, price: Number(b.dataset.price) || 0, image: b.dataset.img, url: b.dataset.url }], { label: b.dataset.name, quiet: flew, land: !flew });
  });
  refresh();
  // cart page: the same − / + / bin buttons, then the page is fetched again
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cp] [data-cq]'); if (!b) return;
    const box = b.closest('[data-cp]'); if (box.getAttribute('aria-busy') === 'true') return;
    box.setAttribute('aria-busy', 'true');
    try {
      const c = await api(`${C.cartChange}.js`, { id: b.dataset.cq, quantity: Math.max(0, Number(b.dataset.q)) });
      render(c);
      const it = c.items.find((x) => x.key === b.dataset.cq);
      if (it && it.quantity < Number(b.dataset.q)) toast(`Nog maar ${it.quantity} op voorraad`);
    } catch (err) { toast(err.message); }
    await refreshCartPage();
    box.removeAttribute('aria-busy');
  });
  return { add, open, refresh, setCode, bump, get state() { return state; } };
})();

// ---------- promo code: copy, and apply it to the cart straight away ----------
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-copy]'); if (!b) return;
  const code = b.dataset.copy;
  navigator.clipboard?.writeText(code).catch(() => {});
  cart.setCode?.(code, { silent: true });
  toast(`Code ${code} gekopieerd en klaargezet in je winkelwagen`);
});

// ---------- promo bar: rotate the messages ----------
onSection((root) => {
  const bar = $('[data-promo]', root);
  const msgs = bar ? $$('.promo__msg', bar) : [];
  if (msgs.length < 2) return;
  let i = 0, paused = false;
  const show = (n) => msgs.forEach((m, k) => {
    m.classList.toggle('is-on', k === n);
    m.setAttribute('aria-hidden', String(k !== n));
    $$('button', m).forEach((b) => (b.tabIndex = k === n ? 0 : -1));
  });
  bar.addEventListener('pointerenter', () => (paused = true));
  bar.addEventListener('pointerleave', () => (paused = false));
  bar.addEventListener('focusin', () => (paused = true));
  bar.addEventListener('focusout', () => (paused = false));
  const iv = setInterval(() => {
    if (!bar.isConnected) { clearInterval(iv); return; } // replaced by the theme editor
    if (!paused && !document.hidden) show((i = (i + 1) % msgs.length));
  }, (Number(bar.dataset.interval) || 5) * 1000);
});

// ---------- header: mega menu (desktop) ----------
onSection((root) => {
  const nav = $('[data-mega-nav]', root);
  if (!nav) return;
  const toggles = $$('[data-mega-toggle]', nav);
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  let openBtn = null, closeT = 0, openT = 0;
  const panelOf = (b) => document.getElementById(b.getAttribute('aria-controls'));
  function close() {
    if (!openBtn) return;
    openBtn.setAttribute('aria-expanded', 'false'); panelOf(openBtn).hidden = true; openBtn = null;
  }
  function open(b) {
    if (openBtn === b) return;
    close(); openBtn = b; b.setAttribute('aria-expanded', 'true'); panelOf(b).hidden = false;
  }
  toggles.forEach((b) => {
    b.addEventListener('click', () => (openBtn === b ? close() : open(b)));
    b.addEventListener('pointerenter', () => { if (!hover.matches) return; clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(() => open(b), openBtn ? 0 : 90); });
  });
  // leaving the row or the panel closes after a short grace, so moving the mouse down into the panel works
  nav.addEventListener('pointerleave', () => { if (!hover.matches) return; clearTimeout(openT); closeT = setTimeout(close, 180); });
  nav.addEventListener('pointerenter', () => clearTimeout(closeT));
  $$('.hdr__items > li > a', nav).forEach((a) => a.addEventListener('pointerenter', () => { if (hover.matches) { clearTimeout(openT); close(); } }));
  document.addEventListener('click', (e) => { if (openBtn && !nav.contains(e.target)) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openBtn) { const b = openBtn; close(); b.focus(); } });
  nav.addEventListener('focusout', (e) => { if (openBtn && !nav.contains(e.relatedTarget)) close(); });
});

// ---------- header: mobile drawer ----------
onSection((root) => {
  const drawer = $('[data-drawer]', root), opener = $('[data-drawer-open]', root);
  if (!drawer || !opener) return;
  const panel = $('.drawer__panel', drawer);
  const set = (on) => {
    drawer.hidden = !on; opener.setAttribute('aria-expanded', String(on));
    document.documentElement.classList.toggle('is-locked', on);
    if (on) $('[data-drawer-close]:not(.drawer__scrim)', drawer)?.focus(); else opener.focus();
  };
  opener.addEventListener('click', () => set(true));
  $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', () => set(false)));
  drawer.addEventListener('click', (e) => { if (e.target.closest('a[data-cart-open]')) set(false); });
  document.addEventListener('keydown', (e) => {
    if (drawer.hidden) return;
    if (e.key === 'Escape') set(false);
    if (e.key === 'Tab') { // keep focus inside the drawer
      const f = $$('a[href], button', panel).filter((x) => x.offsetParent);
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    }
  });
  $$('[data-acc]', drawer).forEach((b) => b.addEventListener('click', () => {
    const on = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', String(on));
    document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
  }));
  // back to desktop width with the drawer open: close it
  matchMedia('(min-width: 1240px)').addEventListener('change', (m) => { if (m.matches && !drawer.hidden) set(false); });
});

// ---------- live search suggestions ----------
onSection((root) => $$('[data-search]', root).forEach((form) => {
  const input = $('input[type="search"]', form), box = $('[data-suggest]', form);
  let sel = -1, ctrl = null, t = 0;
  const mark = (txt, q) => { const w = norm(q).split(/\s+/)[0]; const i = norm(txt).indexOf(w); return i < 0 || !w ? esc(txt) : esc(txt.slice(0, i)) + '<mark>' + esc(txt.slice(i, i + w.length)) + '</mark>' + esc(txt.slice(i + w.length)); };
  const hide = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); };
  async function draw() {
    const q = input.value.trim();
    if (q.length < 2) { hide(); return; }
    ctrl?.abort(); ctrl = new AbortController();
    let r;
    try { r = await suggest(q, 6, ctrl.signal); } catch (e) { return; }
    if (input.value.trim() !== q) return;
    sel = -1;
    box.innerHTML = r.length
      ? r.map((d, i) => `<a href="${esc(d.u)}" role="option" id="${box.id}-${i}" aria-selected="false"><img src="${esc(sized(d.i, 140))}" alt="" width="64" height="48"><span>${mark(d.n, q)}<small>${esc(d.k)}${d.s ? ` · ${esc(d.s)}` : ''}</small></span><b>${money(d.p)}</b></a>`).join('') + `<a class="suggest__all" href="${searchUrl(q)}">Toon alle resultaten voor “${esc(q)}”</a>`
      : `<a class="suggest__all" href="${searchUrl(q)}">Geen directe match voor “${esc(q)}”, zoek verder</a>`;
    box.hidden = false; input.setAttribute('aria-expanded', 'true');
  }
  input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(draw, 140); });
  input.addEventListener('focus', () => { if (input.value.trim().length > 1) draw(); });
  input.addEventListener('keydown', (e) => {
    const opts = $$('a', box);
    if (box.hidden || !opts.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
      opts.forEach((o, i) => o.setAttribute('aria-selected', String(i === sel)));
      input.setAttribute('aria-activedescendant', opts[sel].id || '');
    } else if (e.key === 'Enter' && sel >= 0) { e.preventDefault(); location.href = opts[sel].href; }
    else if (e.key === 'Escape') hide();
  });
  document.addEventListener('click', (e) => { if (!form.contains(e.target)) hide(); });
}));

// ---------- cut the white studio background out of a sign photo, in the browser ----------
const cutCache = new Map();
// 1. remove only true studio white (near 255, no colour) connected to the photo's edge;
// 2. close holes: a sign is convex (rectangle or cap), so every pixel with sign on all four sides is sign;
// 3. rectangles: cut away the neutral grey metal edge / side shadow, then round the corners slightly.
// Falls back to the plain photo when the result looks wrong (white sign on white, almost nothing left).
function cutout(src, { round = false } = {}) {
  const key = src + (round ? '#round' : '');
  if (cutCache.has(key)) return cutCache.get(key);
  const p = new Promise((resolve) => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => {
      try {
        const W = im.naturalWidth, H = im.naturalHeight, c = document.createElement('canvas'); c.width = W; c.height = H;
        const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0);
        const id = x.getImageData(0, 0, W, H), px = id.data, bg = new Uint8Array(W * H), stack = [];
        // studio background: pure white, or (some photos) black letterbox bars when all four corners are black
        const dark = [0, W - 1, (H - 1) * W, H * W - 1].every((i) => Math.max(px[i * 4], px[i * 4 + 1], px[i * 4 + 2]) < 22);
        const white = dark
          ? (i) => { const o = i * 4; return Math.max(px[o], px[o + 1], px[o + 2]) < 22; }
          : (i) => { const o = i * 4, mx = Math.max(px[o], px[o + 1], px[o + 2]), mn = Math.min(px[o], px[o + 1], px[o + 2]); return mn > 238 && mx - mn < 12; };
        for (let i = 0; i < W; i++) stack.push(i, (H - 1) * W + i);
        for (let j = 0; j < H; j++) stack.push(j * W, j * W + W - 1);
        while (stack.length) {
          const i = stack.pop(); if (bg[i] || !white(i)) continue; bg[i] = 1;
          const cx = i % W; if (cx > 0) stack.push(i - 1); if (cx < W - 1) stack.push(i + 1); if (i >= W) stack.push(i - W); if (i < W * (H - 1)) stack.push(i + W);
        }
        const minX = new Int32Array(H).fill(W), maxX = new Int32Array(H).fill(-1), minY = new Int32Array(W).fill(H), maxY = new Int32Array(W).fill(-1);
        for (let j = 0; j < H; j++) for (let i = 0; i < W; i++) if (!bg[j * W + i]) {
          if (i < minX[j]) minX[j] = i; if (i > maxX[j]) maxX[j] = i; if (j < minY[i]) minY[i] = j; if (j > maxY[i]) maxY[i] = j;
        }
        let x0 = W, y0 = H, x1 = -1, y1 = -1, area = 0;
        for (let j = 0; j < H; j++) for (let i = 0; i < W; i++) {
          const k = j * W + i, inside = i >= minX[j] && i <= maxX[j] && j >= minY[i] && j <= maxY[i];
          const on = inside && (!bg[k] || (i > minX[j] && i < maxX[j] && j > minY[i] && j < maxY[i]));
          px[k * 4 + 3] = on ? 255 : 0;
          if (on) { area++; if (i < x0) x0 = i; if (i > x1) x1 = i; if (j < y0) y0 = j; if (j > y1) y1 = j; }
        }
        if (x1 <= x0 || y1 <= y0 || area < W * H * 0.15) throw new Error('nothing sensible left');
        if (!round) { // grey metal edge or side shadow: neutral grey lines, walked inward from each side (max 8%)
          const band = (get, len) => { // a flat, neutral grey or off-white line (metal edge, shadow); never one with print on it
            let r = 0, g = 0, b = 0, l2 = 0, n = 0;
            for (let t = 0; t < len; t += 2) { const o = get(t) * 4; if (px[o + 3]) { r += px[o]; g += px[o + 1]; b += px[o + 2]; const l = (px[o] + px[o + 1] + px[o + 2]) / 3; l2 += l * l; n++; } }
            if (n < 4) return true;
            r /= n; g /= n; b /= n; const m = (r + g + b) / 3, sd = Math.sqrt(Math.max(0, l2 / n - m * m));
            return Math.max(r, g, b) - Math.min(r, g, b) < 14 && m >= 110 && m <= 250 && sd < 18;
          };
          const lim = (v) => Math.floor(v * 0.08);
          let n;
          for (n = 0; n < lim(x1 - x0) && band((t) => (y0 + t) * W + x0, y1 - y0); n++) x0++; if (n) x0++;
          for (n = 0; n < lim(x1 - x0) && band((t) => (y0 + t) * W + x1, y1 - y0); n++) x1--; if (n) x1--;
          for (n = 0; n < lim(y1 - y0) && band((t) => y0 * W + x0 + t, x1 - x0); n++) y0++; if (n) y0++;
          for (n = 0; n < lim(y1 - y0) && band((t) => y1 * W + x0 + t, x1 - x0); n++) y1--; if (n) y1--;
        }
        // self-check: a light rim left over means a white sign on the white studio (no way to tell them apart),
        // holes in the middle mean the sign itself had white parts; both show better as the plain photo
        let R = 0, G = 0, B = 0, k = 0, holes = 0, mid = 0;
        for (let j = y0; j <= y1; j++) for (let i = x0; i <= x1; i++) {
          const o = (j * W + i) * 4, ring = i < x0 + 3 || j < y0 + 3 || i > x1 - 3 || j > y1 - 3;
          if (ring && px[o + 3]) { R += px[o]; G += px[o + 1]; B += px[o + 2]; k++; }
          const u = (i - x0) / (x1 - x0) - 0.5, v = (j - y0) / (y1 - y0) - 0.5; // middle of the sign: inner box, or inner circle for caps
          if (round ? u * u + v * v < 0.16 : Math.abs(u) < 0.4 && Math.abs(v) < 0.4) { mid++; if (!px[o + 3]) holes++; }
        }
        R /= k || 1; G /= k || 1; B /= k || 1;
        if (!round && Math.max(R, G, B) - Math.min(R, G, B) < 14 && (R + G + B) / 3 > 212) throw new Error('white sign');
        if (holes > mid * 0.004) throw new Error('holes');
        x.putImageData(id, 0, 0);
        const o = document.createElement('canvas'); o.width = x1 - x0 + 1; o.height = y1 - y0 + 1;
        const ox = o.getContext('2d');
        if (!round && ox.roundRect) { ox.beginPath(); ox.roundRect(0, 0, o.width, o.height, Math.max(2, Math.min(o.width, o.height) * 0.022)); ox.clip(); }
        ox.drawImage(c, x0, y0, o.width, o.height, 0, 0, o.width, o.height);
        resolve({ src: o.toDataURL('image/png'), ratio: o.width / o.height, cut: true });
      } catch (e) { resolve({ src, ratio: W_H(im), cut: false }); }
    };
    im.onerror = () => resolve({ src, ratio: 1.25, cut: false });
    im.src = src;
  });
  cutCache.set(key, p);
  return p;
}
window.VTcut = cutout; // used by tools/cut-audit.mjs to check every product photo
const isRound = (d) => /Ø/.test(d?.s || '') || /rond|drankdop/i.test(`${d?.h || ''} ${d?.k || ''}`);
const W_H = (im) => (im.naturalWidth && im.naturalHeight ? im.naturalWidth / im.naturalHeight : 1.25);

// ---------- hero wall: their signs swing on their nails when you move past ----------
onSection((root) => {
  const fit = $('[data-wall-fit]', root), wall = fit && $('[data-wall]', fit); // try-wall's scene carries data-wall too
  if (!wall) return;
  // the wall is as tall as its lowest sign really hangs, so nothing spills onto the text below it
  const resize = () => {
    const h = Math.max(760, ...$$('[data-sign]', wall).map((el) => el.offsetTop + el.offsetHeight)) + 16;
    wall.style.height = `${h}px`; fit.style.setProperty('--wall-h', h);
    wall.style.setProperty('--k', Math.min(1, fit.clientWidth / 800, fit.clientHeight / h));
  };
  new ResizeObserver(resize).observe(fit); resize();
  $$('img', wall).forEach((im) => im.addEventListener('load', resize));
  $$('img[data-cut]', wall).forEach((el) => cutout(el.currentSrc || el.src, { round: el.closest('.sign--round') !== null }).then((c) => { el.src = c.src; }));
  const signs = $$('[data-sign]', wall).map((el) => ({ el, a: 0, v: 0, d: 2.2, cx: 0, cy: 0, r: 0 }));
  if (!reduce) signs.forEach((s) => s.el.classList.add('is-hung'));
  if (reduce) return;
  let raf = 0, last = performance.now(), px = null, stale = true;
  const measure = () => signs.forEach((s) => { const r = s.el.getBoundingClientRect(); s.cx = r.left + r.width / 2; s.cy = r.top + r.height / 2; s.r = Math.max(r.width, r.height) * 0.75; });
  function step(t) {
    const dt = Math.min(0.032, (t - last) / 1000); last = t;
    let moving = false;
    for (const s of signs) {
      s.v += (-38 * s.a - s.d * s.v) * dt;   // spring back to hanging straight, with damping
      s.a += s.v * dt;
      s.a = Math.max(-16, Math.min(16, s.a));
      s.el.style.setProperty('--a', `${s.a.toFixed(2)}deg`);
      if (Math.abs(s.a) > 0.05 || Math.abs(s.v) > 0.05) moving = true;
    }
    raf = moving ? requestAnimationFrame(step) : 0;
  }
  const kick = () => { if (!raf) { last = performance.now(); raf = requestAnimationFrame(step); } };
  // on arrival an invisible gust crosses the wall from left to right: each sign gets a push as the front passes it,
  // and settles a little faster than usual, so it reads as a short shiver, not a long swing
  setTimeout(() => {
    measure(); stale = false;
    const xs = signs.map((s) => s.cx), min = Math.min(...xs), span = Math.max(1, Math.max(...xs) - min);
    signs.forEach((s) => {
      setTimeout(() => {
        s.d = 4.2; s.v += 34 + Math.random() * 16; kick();
        setTimeout(() => { s.d = 2.2; }, 1400);
      }, ((s.cx - min) / span) * 650);
    });
  }, 500);
  // sign positions go stale on scroll or resize; measure again on the next pointer move
addEventListener('scroll', () => { px = null; stale = true; }, { passive: true });
addEventListener('resize', () => { stale = true; });
  fit.addEventListener('pointerenter', () => { measure(); stale = false; });
  fit.addEventListener('pointermove', (e) => {
    if (stale) { measure(); stale = false; }
    if (px !== null) {
      const vx = e.clientX - px;
      for (const s of signs) {
        const d = Math.hypot(e.clientX - s.cx, e.clientY - s.cy);
        if (d < s.r) s.v += vx * 1.6 * (1 - d / s.r);
      }
      kick();
    }
    px = e.clientX;
  });
  fit.addEventListener('pointerleave', () => { px = null; });
  // a tap on touch gives the sign a nudge before the link opens on the second tap
  if (!fine) signs.forEach((s) => s.el.addEventListener('click', (e) => { if (!s.el.dataset.tapped) { e.preventDefault(); s.el.dataset.tapped = '1'; s.v += 70; kick(); setTimeout(() => delete s.el.dataset.tapped, 2500); } }));
});

// ---------- theme tiles: fan out their own signs, cut free from the white studio background ----------
onSection((root) => {
  const imgs = $$('[data-cut-src]', root);
  if (!imgs.length) return;
  const io = new IntersectionObserver((es) => es.forEach((en) => {
    if (!en.isIntersecting) return;
    io.unobserve(en.target);
    const el = en.target;
    cutout(el.dataset.cutSrc, { round: el.hasAttribute('data-round') }).then((c) => {
      el.src = c.src; el.classList.toggle('is-photo', !c.cut); el.classList.add('is-cut');
      // a sign that could not be cut out cleanly (white on white) leaves the fan, as long as another sign stays
      const fan = el.parentElement;
      if (!c.cut && $$('img', fan).some((x) => x !== el && !x.classList.contains('is-photo'))) el.hidden = true;
      $$('img:not([hidden])', fan).forEach((x, k, all) => x.style.setProperty('--k', all.length === 2 ? k * 2 : k)); // two left: fan them wide
    });
  }), { rootMargin: '300px' });
  imgs.forEach((el) => io.observe(el));
});

// ---------- rails sorted by Shopify (newest / best-selling) ----------
onSection((root) => $$('[data-rail-src]', root).forEach(async (ul) => {
  try {
    const r = await fetch(ul.dataset.railSrc);
    if (!r.ok) return;
    const items = $$('[data-rail-items] > li', parseHTML(await r.text())).slice(0, Number(ul.dataset.limit) || 12);
    if (items.length) ul.replaceChildren(...items);
  } catch (e) { /* keep the server-rendered fallback */ }
}));

// ---------- product rails: page by page with arrows and dots ----------
function railPager(wrap) {
  const track = $('[data-rail]', wrap), nav = $('[data-rail-nav]', wrap), dots = $('[data-rail-dots]', wrap);
  if (!track || !nav || wrap.dataset.pager) return;
  wrap.dataset.pager = '1';
  const prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
  let pages = 1, per = 1;
  const items = () => [...track.children];
  function measure() {
    const it = items(); if (!it.length) return;
    const w = it[0].getBoundingClientRect().width, gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    per = Math.max(1, Math.floor((track.clientWidth + gap + 2) / (w + gap)));
    pages = Math.ceil(it.length / per);
    nav.hidden = pages < 2;
    dots.innerHTML = Array.from({ length: pages }, (_, i) => `<button type="button" aria-label="Groep ${i + 1} van ${pages}"></button>`).join('');
    sync();
  }
  const current = () => Math.min(pages - 1, Math.round(track.scrollLeft / Math.max(1, track.scrollWidth - track.clientWidth) * (pages - 1)) || 0);
  function sync() {
    const c = current();
    $$('button', dots).forEach((b, i) => b.setAttribute('aria-current', String(i === c)));
    prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
  }
  const go = (page) => { const it = items()[Math.max(0, Math.min(pages - 1, page)) * per]; if (it) track.scrollTo({ left: it.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); };
  prev.addEventListener('click', () => go(current() - 1));
  next.addEventListener('click', () => go(current() + 1));
  dots.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) go($$('button', dots).indexOf(b)); });
  let raf = 0;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
  new ResizeObserver(measure).observe(track);
  new MutationObserver(measure).observe(track, { childList: true }); // rails filled later (newest, recommendations)
  measure();
}
onSection((root) => $$('[data-rail-wrap]', root).forEach(railPager));

// ---------- related products (recommendations API) ----------
onSection((root) => $$('[data-related]', root).forEach(async (sec) => {
  if (sec.children.length) return;
  try {
    const r = await fetch(sec.dataset.url);
    const el = $('[data-related]', parseHTML(await r.text()));
    if (el && el.children.length) { sec.replaceChildren(...el.children); $$('[data-rail-wrap]', sec).forEach(railPager); }
  } catch (e) { /* no recommendations */ }
}));

// ---------- cart page upsell: a sign added from the rail leaves it, it is in the cart now ----------
onSection((root) => $$('[data-upsell]', root).forEach((sec) => sec.addEventListener('click', (e) => {
  const li = e.target.closest('[data-add]')?.closest('li'); if (li) setTimeout(() => li.remove(), 450);
})));

// ---------- room furniture (homepage wall + product page), drawn in real centimetres ----------
// One piece per room; CSS shows the one matching the scene's data-wall. viewBox units are cm, the floor is the bottom edge.
// ROOM_TOPS is the furniture height in cm: signs hang above it.
const ROOM_TOPS = { brick: 110, tiles: 92, wood: 80, plaster: 86 };
let furnN = 0;
function roomFurniture() {
  const u = `f${++furnN}`;
  const stool = (x) => `<g><path d="M${x - 12} 70 ${x - 16} 142M${x + 12} 70 ${x + 16} 142" stroke="#bdb8b0" stroke-width="1.6"/><path d="M${x} 70v72" stroke="#6f6b66" stroke-width="1.4"/>
    <rect x="${x - 15}" y="110" width="30" height="1.6" rx=".8" fill="#d4cfc7"/><rect x="${x - 6}" y="69.5" width="12" height="2.5" fill="#4a4743"/>
    <rect x="${x - 19}" y="63.5" width="38" height="7" rx="3.4" fill="url(#sl${u})"/><rect x="${x - 15}" y="64.4" width="30" height="1.1" rx=".5" fill="#8a6a52" opacity=".55"/></g>`;
  const cushions = (x0, y, w, h, n, gap, fill, r) => Array.from({ length: n }, (_, i) => `<rect x="${x0 + i * (w + gap)}" y="${y}" width="${w}" height="${h}" rx="${r}" fill="${fill}"/>`).join('');
  return `
  <svg class="furn" data-for="brick" viewBox="0 0 220 142" style="--w:220;--h:142;--cx:110" aria-hidden="true">
    <defs>
      <linearGradient id="bw${u}" x2="1"><stop offset="0" stop-color="#3a2415"/><stop offset=".5" stop-color="#52341e"/><stop offset="1" stop-color="#33200f"/></linearGradient>
      <linearGradient id="bt${u}" x2="0" y2="1"><stop offset="0" stop-color="#9a6638"/><stop offset=".4" stop-color="#6e4627"/><stop offset="1" stop-color="#3e2614"/></linearGradient>
      <linearGradient id="bp${u}" x2="0" y2="1"><stop offset="0" stop-color="#5c3b23"/><stop offset="1" stop-color="#402817"/></linearGradient>
      <linearGradient id="br${u}" x2="0" y2="1"><stop offset="0" stop-color="#f5d98f"/><stop offset=".5" stop-color="#b8892f"/><stop offset="1" stop-color="#6e4f17"/></linearGradient>
      <linearGradient id="sl${u}" x2="0" y2="1"><stop offset="0" stop-color="#4f3828"/><stop offset="1" stop-color="#1e140e"/></linearGradient>
    </defs>
    <path d="M42.8 2h2.4v7c0 1.6 2.8 3 2.8 6v17h-8V15c0-3 2.8-4.4 2.8-6z" fill="#2c5527"/><rect x="41.2" y="17" width="1.2" height="12" fill="#fff" opacity=".18"/>
    <path d="M55.5 5h3v8l2.5 2v17h-8V15l2.5-2z" fill="#a8621b"/><rect x="53.6" y="19" width="5.8" height="6" fill="#efe3c4"/><rect x="55.3" y="4" width="3.4" height="2.4" fill="#151515"/>
    <path d="M66.3 4h2.4v6c0 1 2.3 2 2.3 4.5V32h-7V14.5c0-2.5 2.3-3.5 2.3-4.5z" fill="#d4e6e8" opacity=".6"/>
    <path d="M150 23.5h7l-.6 8.5h-5.8z" fill="#dfecef" opacity=".45"/><path d="M150.4 28h6.2l-.3 4h-5.6z" fill="#a8621b" opacity=".85"/>
    <path d="M160 23.5h7l-.6 8.5h-5.8z" fill="#dfecef" opacity=".45"/>
    <rect x="20" y="38" width="180" height="96" fill="url(#bw${u})"/>
    <g fill="url(#bp${u})" stroke="#22150b" stroke-width=".6"><rect x="25" y="46" width="39.5" height="68" rx="1"/><rect x="68.5" y="46" width="39.5" height="68" rx="1"/><rect x="112" y="46" width="39.5" height="68" rx="1"/><rect x="155.5" y="46" width="39.5" height="68" rx="1"/></g>
    <g fill="none" stroke="#000" stroke-opacity=".22" stroke-width=".5"><rect x="29" y="50" width="31.5" height="60"/><rect x="72.5" y="50" width="31.5" height="60"/><rect x="116" y="50" width="31.5" height="60"/><rect x="159.5" y="50" width="31.5" height="60"/></g>
    <rect x="20" y="38" width="180" height="3" fill="#000" opacity=".35"/>
    <rect x="14" y="32" width="192" height="6" rx="1" fill="url(#bt${u})"/><rect x="14" y="32" width="192" height=".8" fill="#b88552" opacity=".7"/>
    <rect x="22" y="134" width="176" height="8" fill="#160d07"/>
    <g fill="#8a6522"><rect x="34" y="119" width="2" height="5"/><rect x="109" y="119" width="2" height="5"/><rect x="184" y="119" width="2" height="5"/></g>
    <rect x="16" y="117.5" width="188" height="3" rx="1.5" fill="url(#br${u})"/>
    ${stool(62)}${stool(158)}
  </svg>
  <svg class="furn" data-for="tiles" viewBox="0 0 260 135" style="--w:260;--h:135;--cx:130" aria-hidden="true">
    <defs>
      <linearGradient id="ok${u}" x2="0" y2="1"><stop offset="0" stop-color="#d7a96c"/><stop offset="1" stop-color="#a87843"/></linearGradient>
      <linearGradient id="fr${u}" x2="0" y2="1"><stop offset="0" stop-color="#465052"/><stop offset="1" stop-color="#363e40"/></linearGradient>
      <linearGradient id="st${u}" x2="1"><stop offset="0" stop-color="#8e8a84"/><stop offset=".45" stop-color="#eeeae3"/><stop offset="1" stop-color="#7d7973"/></linearGradient>
      <linearGradient id="gl${u}" x2="1" y2="1"><stop offset="0" stop-color="#3a3d3f"/><stop offset=".5" stop-color="#1b1c1d"/><stop offset="1" stop-color="#111"/></linearGradient>
    </defs>
    <path d="M18 33h12l-1.6 10h-8.8z" fill="#b5653a"/><circle cx="21" cy="28" r="4" fill="#5f7d45"/><circle cx="26" cy="25" r="4.5" fill="#6f8f52"/><circle cx="24" cy="30" r="3.6" fill="#4d693a"/>
    <path d="M40 43V20q0-7 7-7t7 7v3" fill="none" stroke="url(#st${u})" stroke-width="2.2" stroke-linecap="round"/><rect x="37.5" y="39" width="5" height="4" rx="1" fill="url(#st${u})"/><rect x="42" y="30" width="5" height="1.4" rx=".7" fill="#bcb7af"/>
    <g transform="rotate(-5 188 43)"><rect x="175" y="10" width="26" height="33" rx="3" fill="#d6a96f" stroke="#b0824c" stroke-width=".5"/><circle cx="188" cy="15" r="1.8" fill="#cfcac0"/></g>
    <path d="M208 25l-3-10M213 25l1-12M217 25l4-9" stroke="#8a5b33" stroke-width="1.2" stroke-linecap="round"/><rect x="205" y="25" width="14" height="18" rx="2" fill="#ece7dd" stroke="#cfc8bb" stroke-width=".5"/>
    <rect x="10" y="47" width="240" height="78" fill="#2a3032"/>
    <g fill="url(#fr${u})"><rect x="10.3" y="47.6" width="29.4" height="77"/><rect x="40.3" y="47.6" width="29.4" height="77"/>
      <rect x="70.3" y="47.6" width="59.4" height="21.4"/><rect x="70.3" y="69.5" width="59.4" height="27"/><rect x="70.3" y="97" width="59.4" height="27.6"/>
      <rect x="130.3" y="47.6" width="59.4" height="11.4"/><rect x="190.3" y="47.6" width="59.4" height="77"/></g>
    <rect x="130.3" y="59.5" width="59.4" height="65.1" fill="url(#gl${u})"/><rect x="138" y="72" width="44" height="42" rx="1.5" fill="#0d0e0f" stroke="#2c2f31" stroke-width=".6"/><path d="M140 112l14-38h6l-14 38z" fill="#fff" opacity=".05"/>
    <g fill="#9a978f"><circle cx="140" cy="53.3" r="1.5"/><circle cx="147" cy="53.3" r="1.5"/><circle cx="154" cy="53.3" r="1.5"/></g><rect x="165" y="51.8" width="16" height="3" rx=".5" fill="#0b0b0b"/>
    <g fill="url(#st${u})"><rect x="140" y="63.5" width="40" height="1.6" rx=".8"/><rect x="15" y="51" width="12" height="1.3" rx=".6"/><rect x="53" y="51" width="12" height="1.3" rx=".6"/>
      <rect x="90" y="51.5" width="20" height="1.3" rx=".6"/><rect x="90" y="73" width="20" height="1.3" rx=".6"/><rect x="90" y="100.5" width="20" height="1.3" rx=".6"/><rect x="226" y="51" width="18" height="1.3" rx=".6"/></g>
    <rect x="10" y="47" width="240" height="1.6" fill="#000" opacity=".35"/>
    <rect x="6" y="43" width="248" height="4" fill="url(#ok${u})"/><rect x="6" y="43" width="248" height=".6" fill="#f0c890" opacity=".7"/>
    <rect x="12" y="125" width="236" height="10" fill="#1a1e1f"/>
  </svg>
  <svg class="furn" data-for="wood" viewBox="0 0 250 120" style="--w:250;--h:120;--cx:120" aria-hidden="true">
    <defs>
      <linearGradient id="tk${u}" x2="0" y2="1"><stop offset="0" stop-color="#c8935e"/><stop offset="1" stop-color="#8f5f37"/></linearGradient>
      <linearGradient id="cu${u}" x2="0" y2="1"><stop offset="0" stop-color="#f1ebdf"/><stop offset="1" stop-color="#d3c9b6"/></linearGradient>
    </defs>
    <rect x="30" y="40" width="180" height="50" rx="1.5" fill="url(#tk${u})"/>
    <g stroke="#6e4527" stroke-opacity=".45" stroke-width=".6">${Array.from({ length: 17 }, (_, i) => `<path d="M${40 + i * 10} 40v50"/>`).join('')}</g>
    <g stroke="#c8bda8" stroke-width=".5">${cushions(38, 44, 53, 36, 3, 2.5, `url(#cu${u})`, 6)}</g>
    <rect x="28" y="90" width="184" height="6" fill="url(#tk${u})"/><rect x="28" y="95" width="184" height="1" fill="#000" opacity=".25"/>
    <g stroke="#c8bda8" stroke-width=".5">${cushions(38, 77, 53, 13, 3, 2.5, `url(#cu${u})`, 3)}</g>
    <rect x="47" y="57" width="22" height="20" rx="4" fill="#c9962e" transform="rotate(-8 58 67)"/>
    <g fill="url(#tk${u})"><rect x="25" y="60" width="12" height="60"/><rect x="203" y="60" width="12" height="60"/><rect x="118" y="96" width="4" height="24" opacity=".7"/></g>
    <g fill="#d6a46c"><rect x="22" y="57" width="18" height="4" rx="1"/><rect x="200" y="57" width="18" height="4" rx="1"/></g>
    <path d="M224 90h22l-2 30h-18z" fill="#2f3335"/><rect x="223" y="88" width="24" height="3" rx="1" fill="#3c4144"/>
    <g fill="#5b7848"><ellipse cx="235" cy="76" rx="13" ry="9"/><ellipse cx="229" cy="62" rx="9" ry="10"/></g><g fill="#6f8c57"><ellipse cx="241" cy="58" rx="8" ry="11"/><ellipse cx="236" cy="47" rx="7" ry="8"/></g><g fill="#4a6440"><ellipse cx="243" cy="74" rx="6" ry="7"/><ellipse cx="226" cy="77" rx="6" ry="5"/></g>
  </svg>
  <svg class="furn" data-for="plaster" viewBox="0 0 275 160" style="--w:275;--h:160;--cx:125" aria-hidden="true">
    <defs>
      <linearGradient id="le${u}" x2="0" y2="1"><stop offset="0" stop-color="#ab6b3f"/><stop offset="1" stop-color="#7c4524"/></linearGradient>
      <linearGradient id="ll${u}" x2="0" y2="1"><stop offset="0" stop-color="#bb7b4f"/><stop offset="1" stop-color="#8d5130"/></linearGradient>
      <radialGradient id="gw${u}"><stop offset="0" stop-color="#ffe7b0" stop-opacity=".55"/><stop offset="1" stop-color="#ffe7b0" stop-opacity="0"/></radialGradient>
    </defs>
    <circle cx="255" cy="26" r="34" fill="url(#gw${u})"/>
    <rect x="254.3" y="30" width="1.4" height="128" fill="#2a2622"/><ellipse cx="255" cy="158.5" rx="10" ry="1.8" fill="#221f1c"/>
    <path d="M244 10h22l4 20h-30z" fill="#f1e7d1"/><ellipse cx="255" cy="30.5" rx="14" ry="2" fill="#fff3d0"/>
    <rect x="28" y="74" width="194" height="50" rx="8" fill="url(#le${u})"/>
    <g stroke="#6a3a1f" stroke-width=".4">${cushions(42, 78, 54.5, 36, 3, 1.25, `url(#ll${u})`, 6)}</g>
    <rect x="22" y="122" width="206" height="26" rx="3" fill="#6a3a1f"/>
    <g stroke="#6a3a1f" stroke-width=".4">${cushions(42, 109.5, 54.5, 14, 3, 1.25, `url(#ll${u})`, 4)}</g>
    <rect x="49" y="86" width="24" height="23" rx="5" fill="#d1a03a" transform="rotate(-10 61 98)"/>
    <g transform="rotate(8 189 99)"><rect x="177" y="88" width="24" height="22" rx="5" fill="#ece4d4"/><path d="M177 99h24" stroke="#b9ab8f" stroke-width="2"/></g>
    <rect x="20" y="98" width="24" height="50" rx="9" fill="url(#le${u})"/><rect x="206" y="98" width="24" height="50" rx="9" fill="url(#le${u})"/>
    <g fill="#c58a5c" opacity=".35"><rect x="23" y="99.5" width="18" height="1.5" rx=".7"/><rect x="209" y="99.5" width="18" height="1.5" rx=".7"/></g>
    <g fill="#3a2616"><path d="M27 148h5l-1 12h-3z"/><path d="M218 148h5l-1 12h-3z"/></g>
  </svg>`;
}

// ---------- try it on your wall ----------
onSection((root) => {
  const room = $('[data-room]', root);
  if (!room) return;
  const scene = $('[data-scene]', room), canvas = $('[data-canvas]', room), tray = $('[data-tray]', room);
  const empty = $('[data-empty]', room), sum = $('[data-room-sum]', room), toCart = $('[data-room-cart]', room);
  const defaults = json($('[data-room-products]', room)) || [];
  const byHandle = new Map(defaults.map((d) => [d.h, d]));
  const cm = () => scene.clientWidth / (scene.clientWidth < 640 ? 200 : 380);   // phones show a narrower piece of wall
  const setCm = () => scene.style.setProperty('--cm', `${cm()}px`);
  const hung = [];
  const furn = $('.room__furniture', scene);
  if (furn) furn.innerHTML = roomFurniture();
  new ResizeObserver(() => { setCm(); hung.forEach(place); }).observe(scene); setCm();
  // sign size in cm (long side follows the photo's orientation)
  const dims = (it) => { const s = sizeOf(it.d, it.ratio) || { w: 30, h: 20 }, w = it.ratio >= 1 ? Math.max(s.w, s.h) : Math.min(s.w, s.h); return { w, h: w / it.ratio }; };
  // highest centre (as a fraction of the scene) that keeps the sign `gap` cm above the furniture
  const aboveFurniture = (it, gap) => {
    const k = cm(), H = scene.clientHeight, h = dims(it).h * k;
    const sunk = parseFloat(getComputedStyle(scene).getPropertyValue('--floor')) || 0;   // phones: the furniture sits lower in the frame
    return Math.max(0.06, (H - ((ROOM_TOPS[scene.dataset.wall] || 80) - sunk + gap) * k - h / 2) / H);
  };
  const drawTray = (list) => {
    list.forEach((d) => byHandle.set(d.h, d));
    tray.innerHTML = list.length ? list.slice(0, 24).map((d) => `<li><button type="button" data-hang="${esc(d.h)}"><img src="${esc(sized(d.i, 260))}" alt="" width="130" height="104" loading="lazy"><span>${esc(d.n)}</span></button></li>`).join('') : '<li class="tray__none">Geen bord gevonden. Probeer een ander woord.</li>';
  };
  drawTray(defaults);
  let ctrl = null, t = 0;
  const input = $('[data-tray-search] input', room);
  input.addEventListener('input', () => {
    clearTimeout(t);
    t = setTimeout(async () => {
      const q = input.value.trim();
      if (q.length < 2) { drawTray(defaults); return; }
      ctrl?.abort(); ctrl = new AbortController();
      try { const r = (await suggest(q, 10, ctrl.signal)).filter((d) => d.i); if (input.value.trim() === q) drawTray(r); } catch (e) { /* aborted */ }
    }, 160);
  });
  $('[data-tray-search]', room).addEventListener('submit', (e) => e.preventDefault());
  $$('[data-set-wall]', room).forEach((b) => b.addEventListener('click', () => {
    scene.dataset.wall = b.dataset.setWall;
    $$('[data-set-wall]', room).forEach((x) => x.setAttribute('aria-checked', String(x === b)));
    // a taller piece of furniture (the bar) lifts signs that would now hang in front of it
    hung.forEach((it) => { it.y = Math.min(it.y, aboveFurniture(it, 5)); place(it); });
  }));
  function place(it) {
    const w = dims(it).w * cm();
    it.el.style.width = `${w}px`;
    it.el.style.left = `${it.x * scene.clientWidth - w / 2}px`;
    it.el.style.top = `${it.y * scene.clientHeight - (w / it.ratio) / 2}px`;
  }
  function update() {
    const total = hung.reduce((a, it) => a + it.d.p, 0);
    sum.textContent = hung.length ? `${hung.length} ${hung.length === 1 ? 'wandbord' : 'wandborden'} · ${money(total)}` : '0 wandborden';
    toCart.disabled = !hung.length; empty.hidden = !!hung.length;
  }
  async function hang(d) {
    if (!d) return;
    d = await withVariant(d);
    const { src, ratio } = await cutout(sized(d.i, 500), { round: isRound(d) });
    const el = document.createElement('div');
    el.className = 'hung'; el.tabIndex = 0; el.setAttribute('role', 'img'); el.setAttribute('aria-label', `${d.n}, versleep met muis, vinger of pijltjes`);
    el.innerHTML = `<img src="${src}" alt=""><button type="button" aria-label="Haal ${esc(d.n)} van de muur"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`;
    const n = hung.length;
    const it = { d, el, ratio, x: 0.22 + ((n * 0.19) % 0.58), y: 0 };
    it.y = Math.max(0.06, aboveFurniture(it, scene.dataset.wall === 'brick' ? 48 : 20) - (n % 2) * 0.12);   // clear of the bottles on the bar; every other sign one row higher
    hung.push(it); canvas.append(el); place(it); update();
    if (!reduce) el.animate([{ transform: 'translateY(-30px) rotate(-6deg)', opacity: 0 }, { transform: 'rotate(3deg)', opacity: 1, offset: 0.6 }, { transform: 'none' }], { duration: 700, easing: 'cubic-bezier(.22,1,.36,1)' });
    $('button', el).addEventListener('click', (e) => { e.stopPropagation(); el.remove(); hung.splice(hung.indexOf(it), 1); update(); });
    let sx, sy, ox, oy;
    el.addEventListener('pointerdown', (e) => { if (e.target.closest('button')) return; el.setPointerCapture(e.pointerId); el.classList.add('is-drag'); sx = e.clientX; sy = e.clientY; ox = it.x; oy = it.y; });
    el.addEventListener('pointermove', (e) => { if (!el.classList.contains('is-drag')) return; it.x = Math.max(0.03, Math.min(0.97, ox + (e.clientX - sx) / scene.clientWidth)); it.y = Math.max(0.06, Math.min(0.9, oy + (e.clientY - sy) / scene.clientHeight)); place(it); });
    const up = () => el.classList.remove('is-drag');
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); $('button', el).click(); return; }
      const m = { ArrowLeft: [-0.02, 0], ArrowRight: [0.02, 0], ArrowUp: [0, -0.02], ArrowDown: [0, 0.02] }[e.key]; if (!m) return;
      e.preventDefault(); it.x = Math.max(0.03, Math.min(0.97, it.x + m[0])); it.y = Math.max(0.06, Math.min(0.9, it.y + m[1])); place(it);
    });
  }
  tray.addEventListener('click', (e) => { const b = e.target.closest('[data-hang]'); if (b) hang(byHandle.get(b.dataset.hang)); });
  toCart.addEventListener('click', async () => {
    const q = new Map();
    hung.forEach((it) => { if (it.d.id) q.set(it.d.id, (q.get(it.d.id) || 0) + 1); });
    const byId = new Map(hung.map((it) => [it.d.id, it.d]));
    const items = [...q].map(([id, quantity]) => { const d = byId.get(id); return { id, quantity, title: d.n, price: d.p, image: d.i ? sized(d.i, 160) : '', url: d.u }; });
    toast(`${hung.length} ${hung.length === 1 ? 'wandbord' : 'wandborden'} in je winkelwagen`);
    const done = cart.add(items, { quiet: true });
    cart.open(); await done;
  });
  // start with a couple of signs on the wall so the idea is obvious at a glance
  const start = Number(room.dataset.start) || 0;
  const io = new IntersectionObserver(([en]) => {
    if (!en.isIntersecting) return;
    io.disconnect();
    [defaults[0], defaults[2], defaults[1]].slice(0, start).reduce((p, d) => p.then(() => hang(d)), Promise.resolve());
  }, { rootMargin: '200px' });
  io.observe(room);
});

// ---------- proverb shuffle ----------
onSection((root) => {
  const st = $('[data-shuffle-stage]', root);
  if (!st) return;
  let pool = json($('[data-pool]', st)) || [], loaded = false;
  const sign = $('.shuffle__sign', st), im = $('[data-shuffle-img]', st), name = $('[data-shuffle-name]', st), price = $('[data-shuffle-price]', st);
  const link = $('[data-shuffle-link]', root);
  let cur = pool[0];
  // the sign hangs from its nail like on the hero wall: cut free from the studio photo, or as a framed photo if it is white on white
  let ticket = 0;
  async function show(d, { swing = false } = {}) {
    const t = ++ticket;
    const c = await cutout(sized(d.i, 700), { round: isRound(d) });
    if (t !== ticket) return; // a newer shuffle won
    cur = d; im.src = c.src; im.alt = d.n; name.textContent = d.n; price.textContent = money(d.p); link.href = d.u;
    sign.classList.toggle('is-photo', !c.cut); sign.classList.toggle('is-round', isRound(d)); im.classList.add('is-ready');
    if (swing && !reduce) { sign.classList.remove('is-swing'); void sign.offsetWidth; sign.classList.add('is-swing'); }
  }
  if (cur) show(cur);
  async function more() { // the Liquid pool holds 50; the rest of the collection loads on first shuffle
    if (loaded) return; loaded = true;
    try {
      for (let page = 1; page <= 4; page++) {
        const r = await fetch(`${st.dataset.src}?limit=250&page=${page}`);
        const ps = (await r.json()).products || [];
        const seen = new Set(pool.map((d) => d.h));
        pool = pool.concat(ps.filter((p) => !seen.has(p.handle) && p.variants?.length && p.images?.length).map(fromProductsJson));
        if (ps.length < 250) break;
      }
    } catch (e) { /* stay with the first 50 */ }
  }
  $('[data-shuffle]', root).addEventListener('click', () => {
    more();
    if (pool.length < 2) return;
    let d; do { d = pool[Math.floor(Math.random() * pool.length)]; } while (d === cur);
    show(d, { swing: true });
  });
});

// ---------- collection + search: Shopify filters and sorting without a page reload ----------
onSection((root) => {
  const sec = $('[data-coll]', root);
  if (!sec) return;
  const id = sec.dataset.section;
  let ctrl = null, t = 0;
  async function load(url, { push = true } = {}) {
    ctrl?.abort(); ctrl = new AbortController();
    sec.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(sectionUrl(url, id), { signal: ctrl.signal });
      const doc = parseHTML(await r.text());
      const active = document.activeElement, key = active?.name ? [active.name, active.value] : null;
      ['[data-results]', '[data-filters]', '[data-n-title]'].forEach((s) => { const a = $(s, sec), b = $(s, doc); if (a && b) a.replaceWith(b); });
      if (push) history.pushState({ vt: 1 }, '', url);
      if (key) $$('[name]', sec).find((x) => x.name === key[0] && x.value === key[1])?.focus({ preventScroll: true });
      bind();
    } catch (e) { if (e.name !== 'AbortError') location.href = url; }
    sec.removeAttribute('aria-busy');
  }
  function urlFrom(form) {
    const p = new URLSearchParams(new FormData(form));
    [...p.keys()].forEach((k) => { if (p.get(k) === '') p.delete(k); });
    const u = new URL(form.action, location.href); u.search = p.toString();
    return u.pathname + u.search;
  }
  function bind() {
    // phones: storefront filters fold away under one button unless one is in use
    const more = $('[data-filters-more]', sec);
    if (more && matchMedia('(max-width: 1180px)').matches && more.dataset.active === '0' && !more.dataset.touched) more.open = false;
    more?.addEventListener('toggle', () => { more.dataset.touched = '1'; });
    const cur = $('a.chip[aria-current]', sec), row = cur?.parentElement;
    if (row && row.scrollWidth > row.clientWidth) row.scrollLeft = cur.offsetLeft - row.offsetLeft - 16;
    const form = $('[data-filters]', sec);
    if (form) {
      form.addEventListener('submit', (e) => { e.preventDefault(); load(urlFrom(form)); });
      form.addEventListener('change', (e) => { clearTimeout(t); t = setTimeout(() => load(urlFrom(form)), e.target.type === 'number' ? 400 : 0); });
    }
    $('[data-sort]', sec)?.addEventListener('change', () => form && load(urlFrom(form)));
    $('[data-more]', sec)?.addEventListener('click', async (e) => {
      e.preventDefault();
      const a = e.currentTarget; a.setAttribute('aria-busy', 'true'); a.textContent = 'Laden…';
      try {
        const doc = parseHTML(await (await fetch(sectionUrl(a.href, id))).text());
        const grid = $('[data-grid]', sec), items = $$('[data-grid] > li', doc);
        items.forEach((li, i) => li.style.setProperty('--i', i % 24));
        grid.append(...items);
        const next = $('[data-more]', doc);
        if (next) { a.href = next.href; a.textContent = 'Meer wandborden laden'; a.removeAttribute('aria-busy'); } else a.parentElement.remove();
        items[0]?.querySelector('a')?.focus({ preventScroll: true });
      } catch (err) { location.href = a.href; }
    });
  }
  bind();
  addEventListener('popstate', () => { if (sec.isConnected) load(location.href, { push: false }); });
});

// ---------- product cards: the product page's photo starts loading as soon as a card is pointed at or touched ----------
// same srcset and sizes as the front image in sections/main-product, so the browser picks the same file and the page opens with it
(() => {
  const warmed = new Set();
  const warm = (e) => {
    const src = e.target.closest?.('.pc')?.querySelector('.pc__img img')?.currentSrc;
    if (!src || warmed.has(src)) return;
    warmed.add(src);
    const im = new Image();
    im.sizes = '(max-width: 1180px) 100vw, 55vw';
    im.srcset = [450, 700, 900, 1100].map((w) => `${sized(src, w)} ${w}w`).join(', ');
  };
  ['pointerover', 'touchstart', 'focusin'].forEach((t) => document.addEventListener(t, warm, { passive: true }));
})();

// ---------- product page ----------
onSection((root) => {
  const pdp = $('[data-pdp]', root);
  if (!pdp) return;
  const d = json($('[data-pdp-json]', pdp));
  const form = $('[data-pdp-form]', pdp), qIn = $('[data-qty-in]', pdp), addBtn = $('[data-pdp-add]', pdp);
  $$('[data-qty]', pdp).forEach((b) => b.addEventListener('click', () => { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) + Number(b.dataset.qty)); }));
  const variant = $('[data-variant]', pdp);
  variant?.addEventListener('change', () => {
    const o = variant.selectedOptions[0];
    $('[data-pdp-price]', pdp).textContent = o.dataset.price;
    const [st, label] = (o.dataset.stock || '').split('|'), cell = $('.pdp__stock', pdp);
    if (cell && st) { cell.dataset.stock = st; $('[data-stock-text]', cell).textContent = label; }
    const u = new URL(location.href); u.searchParams.set('variant', variant.value); history.replaceState(null, '', u);
  });
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    // the drawer opens at once with the sign in it (no toast on top of it); Shopify confirms in the background
    const done = cart.add([{ id: new FormData(form).get('id'), quantity: Math.max(1, parseInt(qIn.value, 10) || 1), title: d?.n, price: d?.p, image: d?.i ? sized(d.i, 160) : '', url: d?.u }], { quiet: true, label: d?.n });
    cart.open(); await done;
  });
  const stage = $('[data-pdp-stage]', pdp), flip = $('[data-flip]', pdp), views = $$('[data-view]', pdp);
  // "Aan de muur": the sign at real size in a small room — the room's furniture and a 50 cm scale give the size away.
  // The stage shows up to 200 cm of wall with the same furniture as the homepage wall; everything is sized in cm (--cm).
  let wallPref = 'brick';
  const WALLS = [['brick', 'Mancave & bar'], ['tiles', 'Keuken'], ['wood', 'Overkapping'], ['plaster', 'Woonkamer']];
  const roomHTML = (d, c) => `<div class="pdp__onwall pdp__room" data-wall="${wallPref}">
      <div class="pdp__glow" aria-hidden="true"></div><i class="pdp__fixture" aria-hidden="true"></i>
      <figure class="pdp__hang"><i class="nail"></i><svg class="sign__wire" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true"><path d="M8 20 50 1 92 20"/></svg><img src="${c.src}" alt="${esc(d.n)} aan de muur, op ware grootte"></figure>
      <div class="room__furniture" aria-hidden="true">${roomFurniture()}</div>
      <p class="room__scale" aria-hidden="true"><span></span>50 cm</p>
      ${d.s ? `<p class="pdp__size">${esc(d.s)} · ware grootte</p>` : ''}
      <div class="pdp__walls" role="radiogroup" aria-label="Kies je ruimte">${WALLS.map(([k, l]) => `<button type="button" role="radio" aria-checked="${k === wallPref}" data-room-wall="${k}">${l}</button>`).join('')}</div>
    </div>`;
  function placeOnWall(room, d, c) {
    const W = stage.clientWidth, H = stage.clientHeight, s = sizeOf(d, c.ratio);
    const round = /Ø/.test(d.s || '');
    const wCm = s ? (c.ratio >= 1 ? Math.max(s.w, s.h) : Math.min(s.w, s.h)) : 60, hCm = wCm / c.ratio;
    const furnTop = ROOM_TOPS[room.dataset.wall] || 80, gap = 25;   // bottom of the sign 25 cm above the furniture
    const roof = H * 0.1 + 28;                                       // room for the light fixture and the nail
    const cm = Math.min(W / 200, (H - roof) / (furnTop + gap + hCm)); // zoom out when a tall piece (the bar) needs more wall
    room.style.setProperty('--cm', `${cm}px`);
    const w = wCm * cm, h = hCm * cm;
    const top = H - (furnTop + gap) * cm - h;
    const fig = $('.pdp__hang', room);
    fig.style.width = `${w}px`; fig.style.top = `${top}px`;
    fig.classList.toggle('is-round', round);
    room.style.setProperty('--sign-top', `${top}px`);
  }
  addEventListener('resize', () => { const room = pdp.isConnected && $('.pdp__room', stage); if (room && d) cutout(sized(d.i, 700), { round: isRound(d) }).then((c) => placeOnWall(room, d, c)); });
  // touch: swipe the photo sideways to step Voorkant → Achterkant → Aan de muur (and back); vertical swipes keep scrolling the page
  let sx = 0, sy = 0, tracking = false;
  stage.addEventListener('touchstart', (e) => { tracking = e.touches.length === 1 && !e.target.closest('button'); sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchend', (e) => {
    if (!tracking) return;
    tracking = false;
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
    const i = views.findIndex((x) => x.getAttribute('aria-pressed') === 'true');
    const next = views[i + (dx < 0 ? 1 : -1)];
    if (!next) return;
    next.click();
    if (!reduce) stage.animate([{ transform: `translateX(${dx < 0 ? 28 : -28}px)`, opacity: 0.4 }, { transform: 'none', opacity: 1 }], { duration: 240, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
  }, { passive: true });
  views.forEach((b) => b.addEventListener('click', async () => {
    views.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    const v = b.dataset.view;
    $('.pdp__onwall', stage)?.remove();
    stage.classList.toggle('is-wall', v === 'wall');
    flip.classList.toggle('is-back', v === 'back');
    if (v === 'wall' && d) {
      const c = await cutout(sized(d.i, 700), { round: isRound(d) });
      if (!stage.classList.contains('is-wall')) return; // visitor switched view while the cut-out was made
      stage.insertAdjacentHTML('beforeend', roomHTML(d, c));
      const room = $('.pdp__room', stage);
      placeOnWall(room, d, c);
      $$('[data-room-wall]', room).forEach((x) => x.addEventListener('click', () => {
        room.dataset.wall = x.dataset.roomWall; wallPref = x.dataset.roomWall;
        $$('[data-room-wall]', room).forEach((y) => y.setAttribute('aria-checked', String(y === x)));
        placeOnWall(room, d, c);
      }));
    }
  }));
});

// ---------- sticky offsets follow the real header height ----------
// measures the whole page each time: the editor may have swapped the header or the promo bar
let headRO = null;
onSection(() => {
  headRO?.disconnect();
  const top = $('[data-header]')?.closest('.shopify-section') || $('[data-header]');
  if (!top) return;
  // the promo bar sticks above the header, so the header sticks below it and offsets count both
  const promo = $('[data-promo]')?.closest('.shopify-section');
  const set = () => {
    const p = promo ? promo.offsetHeight : 0;
    document.documentElement.style.setProperty('--promo-h', `${p}px`);
    document.documentElement.style.setProperty('--header-h', `${p + top.offsetHeight}px`);
  };
  headRO = new ResizeObserver(set); headRO.observe(top); if (promo) headRO.observe(promo); set();
});

// ---------- reviews carousel: arrows, play/pause, gentle auto-advance ----------
onSection((root) => $$('[data-reviews]', root).forEach((sec) => {
  const track = $('[data-rev-track]', sec), play = $('[data-rev-play]', sec);
  if (!track || track.children.length < 2) return;
  const step = () => { const li = track.children[0]; return li.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); };
  const atEnd = () => track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
  const next = () => (atEnd() ? track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }) : go(1));
  $('[data-rev-prev]', sec)?.addEventListener('click', () => go(-1));
  $('[data-rev-next]', sec)?.addEventListener('click', next);
  const ms = (Number(sec.dataset.interval) || 0) * 1000;
  let on = ms > 0 && !reduce, hold = false, timer = 0;
  const sync = () => { play?.setAttribute('aria-pressed', String(on)); play?.setAttribute('aria-label', on ? 'Automatisch doorschuiven pauzeren' : 'Automatisch doorschuiven starten'); };
  const tick = () => { clearTimeout(timer); if (on && sec.isConnected) timer = setTimeout(() => { if (!hold && !document.hidden) next(); tick(); }, ms); };
  if (!ms) play?.remove(); else play?.addEventListener('click', () => { on = !on; sync(); tick(); });
  ['pointerenter', 'focusin'].forEach((ev) => track.addEventListener(ev, () => (hold = true)));
  ['pointerleave', 'focusout'].forEach((ev) => track.addEventListener(ev, () => (hold = false)));
  sync(); tick();
}));

// ---------- quick add with sizes: a popover on desktop, a sheet from the bottom on phones ----------
(() => {
  let root = null, panel = null, lastBtn = null, closing = 0;
  const phone = matchMedia('(max-width: 760px)');
  const build = () => {
    root = document.createElement('div');
    root.className = 'pick'; root.hidden = true;
    root.innerHTML = `<div class="pick__scrim" data-pick-close></div>
      <div class="pick__panel" role="dialog" aria-modal="true" aria-labelledby="pick-title">
        <i class="pick__grab" aria-hidden="true"></i>
        <div class="pick__head"><div><p class="pick__name" id="pick-title"></p><small>Kies een maat</small></div>
          <button type="button" class="pick__x" data-pick-close aria-label="Sluiten"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>
        <ul class="pick__list"></ul>
      </div>`;
    document.body.append(root); panel = $('.pick__panel', root);
    root.addEventListener('click', async (e) => {
      if (e.target.closest('[data-pick-close]')) { close(); return; }
      const o = e.target.closest('[data-variant]'); if (!o || o.disabled) return;
      close();
      const flew = flyToCart(lastBtn?.closest('.pc')?.querySelector('.pc__img img'));
      cart.add([{ id: o.dataset.variant, title: root.dataset.name, price: Number(o.dataset.price) || 0, image: root.dataset.img, url: root.dataset.url }], { label: `${root.dataset.name} (${o.dataset.title})`, quiet: flew, land: !flew });
    });
    document.addEventListener('keydown', (e) => { if (!root.hidden && e.key === 'Escape') close(); });
  };
  function place(btn) {
    if (phone.matches) { panel.style.cssText = ''; return; }
    // over the card, like the card flips open: same width, bottom edge just above the + button
    const card = btn.closest('.pc') || btn, r = card.getBoundingClientRect(), b = btn.getBoundingClientRect();
    const w = Math.max(310, Math.min(380, r.width + 40)), h = panel.offsetHeight;
    const left = Math.min(Math.max(12, r.left + r.width / 2 - w / 2), innerWidth - w - 12);
    const top = Math.min(Math.max(12, b.top - h - 10), innerHeight - h - 12);
    panel.style.cssText = `width:${w}px;left:${left}px;top:${top}px;transform-origin:${b.left + b.width / 2 - left}px 100%`;
  }
  async function open(btn) {
    if (!root) build();
    clearTimeout(closing);
    lastBtn = btn; btn.setAttribute('aria-busy', 'true');
    let p;
    try { p = await (await fetch(`${C.root || '/'}products/${encodeURIComponent(btn.dataset.pick)}.js`)).json(); } catch (e) { toast('Kon de maten niet laden'); return; } finally { btn.removeAttribute('aria-busy'); }
    root.dataset.name = btn.dataset.name || nameOf(p.title);
    root.dataset.img = p.featured_image ? sized(p.featured_image, 160) : ''; root.dataset.url = p.url || '';
    $('.pick__name', root).textContent = root.dataset.name;
    $('.pick__head img', root)?.remove();
    if (p.featured_image) $('.pick__head', root).insertAdjacentHTML('afterbegin', `<img src="${esc(sized(p.featured_image, 120))}" alt="" width="48" height="48">`);
    $('.pick__list', root).innerHTML = p.variants.map((v) => `<li><button type="button" data-variant="${v.id}" data-title="${esc(v.title)}" data-price="${v.price}"${v.available ? '' : ' disabled'}>
      <span>${esc(v.title)}</span><b>${v.available ? `${v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s> ` : ''}${money(v.price)}` : 'Uitverkocht'}</b></button></li>`).join('');
    root.hidden = false; root.classList.toggle('is-sheet', phone.matches);
    place(btn);
    requestAnimationFrame(() => root.classList.add('is-open'));
    if (phone.matches) document.documentElement.classList.add('is-locked');
    $('[data-variant]:not([disabled])', root)?.focus({ preventScroll: true });
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open'); document.documentElement.classList.remove('is-locked');
    closing = setTimeout(() => { root.hidden = true; }, reduce ? 0 : 220);
    lastBtn?.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-pick]'); if (!b) return; e.preventDefault(); open(b); });
  addEventListener('resize', () => { if (root && !root.hidden && !phone.matches && lastBtn) place(lastBtn); });
  addEventListener('scroll', () => { if (root && !root.hidden && !phone.matches) close(); }, { passive: true });
})();

// ---------- wishlist (verlanglijst): handles in the visitor's browser, a heart on every card and product page ----------
const wish = (() => {
  const KEY = 'vt-wishlist';
  const read = () => { try { const a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter((x) => typeof x === 'string') : []; } catch (e) { return []; } };
  let list = read();
  const has = (h) => list.includes(h);
  function sync() {
    $$('[data-wish-count]').forEach((el) => { el.textContent = list.length || ''; el.toggleAttribute('data-zero', !list.length); });
    $$('[data-fav]').forEach((b) => { const on = has(b.dataset.fav); b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-label', on ? 'Verwijder uit verlanglijst' : 'Bewaar in verlanglijst'); });
  }
  function save(next) {
    list = next;
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode: the list lasts this visit */ }
    sync(); document.dispatchEvent(new CustomEvent('vt:wish'));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fav]'); if (!b) return;
    e.preventDefault();
    const h = b.dataset.fav, name = b.dataset.name || 'Bord';
    if (has(h)) { save(list.filter((x) => x !== h)); toast(`${name} uit je verlanglijst`); }
    else { save([h, ...list]); toast(`${name} bewaard in je verlanglijst`); if (!reduce) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'cubic-bezier(.22,1,.36,1)' }); }
  });
  addEventListener('storage', (e) => { if (e.key === KEY) { list = read(); sync(); document.dispatchEvent(new CustomEvent('vt:wish')); } });
  // cards arrive later too (rails, filters, search): mark their hearts as they come in
  let raf = 0;
  new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }).observe(document.body, { childList: true, subtree: true });
  sync();
  return { get list() { return list; }, drop: (hs) => save(list.filter((x) => !hs.includes(x))) };
})();

onSection((root) => $$('[data-wishlist]', root).forEach((sec) => {
  const grid = $('[data-wish-grid]', sec), empty = $('[data-wish-empty]', sec), n = $('[data-wish-n]', sec), actions = $('[data-wish-actions]', sec);
  const toCart = $('[data-wish-cart]', sec), checkout = $('[data-wish-checkout]', sec), avail = $('[data-wish-avail]', sec);
  const cache = new Map();
  // one card per product from the product 'card' view; a product that no longer exists answers 404 and leaves the list
  const card = (h) => {
    if (!cache.has(h)) cache.set(h, fetch(`${C.root || '/'}products/${encodeURIComponent(h)}?view=card`)
      .then((r) => (r.status === 404 ? null : r.ok ? r.text() : ''))
      .then((t) => (t === null ? null : $('li', parseHTML(t || ''))?.outerHTML || ''))
      .catch(() => ''));
    return cache.get(h);
  };
  const ids = () => $$('[data-add]', grid).map((b) => b.dataset.add);
  async function draw() {
    if (!sec.isConnected) return; // replaced by the theme editor
    const hs = wish.list;
    const html = await Promise.all(hs.map(card));
    if (hs !== wish.list) return; // the list changed while loading; the newer draw wins
    const gone = hs.filter((h, i) => html[i] === null);
    if (gone.length) { wish.drop(gone); return; }
    const items = html.filter(Boolean);
    grid.innerHTML = items.map((x, i) => x.replace(/--i:\s*\d+/, `--i:${i}`)).join('');
    n.textContent = `${items.length} ${items.length === 1 ? 'wandbord' : 'wandborden'} opgeslagen`;
    empty.hidden = !!items.length; n.hidden = actions.hidden = !items.length;
    const k = ids().length; avail.textContent = k; toCart.disabled = checkout.disabled = !k;
    const pick = $$('[data-pick]', grid).length, note = $('[data-wish-note]', sec);
    note.hidden = !pick;
    note.textContent = pick === 1 ? 'Bij 1 wandbord kies je eerst een maat: tik op de + bij dat bord.' : `Bij ${pick} wandborden kies je eerst een maat: tik op de + bij die borden.`;
    sec.classList.add('is-ready');
  }
  const addAll = (opts) => cart.add($$('[data-add]', grid).map((b) => ({ id: b.dataset.add, title: b.dataset.name, price: Number(b.dataset.price) || 0, image: b.dataset.img, url: b.dataset.url })), opts);
  toCart.addEventListener('click', () => { addAll({ quiet: true }); cart.open(); });
  checkout.addEventListener('click', async () => { checkout.disabled = true; if (await addAll({ quiet: true })) location.href = `${C.root || '/'}checkout`; else checkout.disabled = false; });
  document.addEventListener('vt:wish', draw);
  draw();
}));

// ---------- veelgestelde vragen: search, topics, fold-open answers, a direct link per question ----------
onSection((root) => $$('[data-faq]', root).forEach((sec) => {
  const items = $$('[data-faq-item]', sec), groups = $$('[data-faq-group]', sec), tabs = $$('[data-faq-tab]', sec);
  const input = $('[data-faq-q]', sec), none = $('[data-faq-none]', sec);
  let topic = 'all';
  const setOpen = (it, open) => { it.classList.toggle('is-open', open); $('button', it).setAttribute('aria-expanded', String(open)); };
  items.forEach((it) => $('h3 button', it).addEventListener('click', () => {
    const open = !it.classList.contains('is-open');
    setOpen(it, open);
    history.replaceState(null, '', open ? `#${it.id}` : location.pathname + location.search);
  }));
  function filter() {
    const q = norm(input.value.trim());
    let shown = 0;
    items.forEach((it) => {
      const hit = (topic === 'all' || it.dataset.group === topic) && (!q || norm(it.textContent).includes(q));
      it.hidden = !hit; if (hit) shown++;
      if (q && hit) setOpen(it, true);
    });
    groups.forEach((g) => { g.hidden = !$$('[data-faq-item]:not([hidden])', g).length; });
    none.hidden = shown > 0;
  }
  let t = 0;
  input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(filter, 120); });
  tabs.forEach((b) => b.addEventListener('click', () => {
    topic = b.dataset.faqTab;
    tabs.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    filter();
  }));
  // a shared link (#vraag-…) opens that question
  const hit = location.hash && items.find((it) => `#${it.id}` === location.hash);
  if (hit) { setOpen(hit, true); requestAnimationFrame(() => hit.scrollIntoView({ block: 'center' })); }
}));

// ---------- withdrawal form (herroepingsfunctie) ----------
onSection((root) => $$('[data-withdrawal]', root).forEach((sec) => {
  const form = $('[data-withdrawal-form]', sec), KEY = 'vt-withdrawal';
  const done = $('[data-withdrawal-done]', sec);
  if (done) { // after sending: show what was sent, with date and time, so the customer can keep it
    let data = null; try { data = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { /* storage blocked */ }
    const dl = $('[data-withdrawal-summary]', sec);
    if (data && dl) {
      dl.innerHTML = data.map(([k, v]) => `<div><dt>${esc(k)}</dt><dd>${esc(v).replace(/\n/g, '<br>')}</dd></div>`).join('');
      dl.hidden = false;
    }
    $('[data-withdrawal-print]', sec)?.addEventListener('click', () => print());
    return;
  }
  if (!form) return;
  const q = new URLSearchParams(location.search), set = (k, v) => { const el = $(`[data-wd="${k}"]`, form); if (el && v && !el.value) el.value = v; };
  set('order', q.get('order')); set('email', q.get('email')); set('name', q.get('name')); set('date', q.get('date'));
  form.addEventListener('submit', () => {
    const now = new Date(), stamp = now.toLocaleString('nl-NL', { dateStyle: 'long', timeStyle: 'short' });
    $('[data-withdrawal-time]', form).value = `${stamp} (${now.toISOString()})`;
    const rows = [['Ingediend op', stamp]];
    $$('label', form).forEach((l) => { const f = $('input, textarea', l); if (f && f.value.trim()) rows.push([$('span', l).textContent.replace(/\s*\*$/, ''), f.value.trim()]); });
    if (!rows.some(([k]) => k === 'Welke producten?')) rows.push(['Welke producten?', 'De hele bestelling']);
    try { sessionStorage.setItem(KEY, JSON.stringify(rows)); } catch (e) { /* storage blocked: the shop still gets everything */ }
  });
}));

// ---------- small things ----------
document.addEventListener('submit', (e) => { const f = e.target.closest('[data-confirm]'); if (f && !confirm(f.dataset.confirm)) e.preventDefault(); });
onSection((root) => $$('select[data-default]', root).forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; }));
// theme editor: start only the re-rendered section again; the preview stays put, so the editor keeps the section you were in
document.addEventListener('shopify:section:load', (e) => inits.forEach((fn) => fn(e.target)));
})();
